// extracted by mini-css-extract-plugin
export default {"container":"YPzKK","videoWrapper":"sCL3J","video":"epXvi","poster":"Lq5uK","skeleton-progress":"urwyR"};